module.exports = __webpack_public_path__ + "static/media/img-goal-16.1b82e44e.jpg";